import React from 'react';
import { Users, Store, UserPlus } from 'lucide-react';
import { ModulePlaceholder } from '@/components/modules/common/ModulePlaceholder';
import { usePartnerOverview } from '@/hooks/usePartnerOverview';

export const LeadsView: React.FC = () => {
  const { data } = usePartnerOverview();

  return (
    <ModulePlaceholder
      title="Referred Stores & Customers"
      subtitle="Track merchants who joined Conversora via your referral link"
      icon={Users}
      badge="Customer Tracking"
    >
      <div className="space-y-6">
        <div className="bg-[#0E1015] border border-zinc-800 rounded-2xl overflow-hidden">
          <div className="px-5 py-4 border-b border-zinc-800 flex items-center justify-between">
            <h2 className="text-sm font-semibold text-white">Referred Merchants</h2>
            <span className="text-xs text-zinc-400">
              Total Active: {data.activeSubscriptions}
            </span>
          </div>

          {data.recentLeads.length === 0 ? (
            <div className="py-14 px-4 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-2xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-zinc-400">
                <Store className="w-5 h-5 text-indigo-400" />
              </div>
              <h3 className="text-sm font-semibold text-white">No referred stores yet</h3>
              <p className="text-xs text-zinc-400 max-w-sm mx-auto mt-1 mb-5 leading-relaxed">
                When merchants register and set up their online store through your link, they will appear here with their subscription status and commission details.
              </p>
              <button
                type="button"
                onClick={() => navigator.clipboard.writeText(data.referralUrl)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-semibold transition cursor-pointer shadow-xs"
              >
                <UserPlus className="w-3.5 h-3.5" />
                <span>Copy Your Referral Link</span>
              </button>
            </div>
          ) : (
            <table className="w-full text-left text-xs">
              <thead className="bg-zinc-900/60 border-b border-zinc-800 text-zinc-400 uppercase tracking-wider text-[10px]">
                <tr>
                  <th className="py-3 px-4">Merchant Name</th>
                  <th className="py-3 px-4">Subscription Plan</th>
                  <th className="py-3 px-4">Joined Date</th>
                  <th className="py-3 px-4 text-center">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800/60">
                {data.recentLeads.map((lead) => (
                  <tr key={lead.id} className="hover:bg-zinc-900/40 transition">
                    <td className="py-3.5 px-4 font-medium text-white">{lead.customerName}</td>
                    <td className="py-3.5 px-4 text-zinc-300">{lead.plan}</td>
                    <td className="py-3.5 px-4 font-mono text-zinc-400">{lead.attributedDate}</td>
                    <td className="py-3.5 px-4 text-center">
                      <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium capitalize bg-emerald-500/10 text-emerald-400 border border-emerald-500/30">
                        {lead.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </ModulePlaceholder>
  );
};

export default LeadsView;
